import FuneralSitePage from './FuneralSitePage';

export default FuneralSitePage;
